import {AuthActions, AuthActionTypes} from '../actions/auth.actions';
import {UserModel} from '../models/user.model';

export interface AuthState {
    loggedIn: boolean;
    authToken: string | undefined;
    user: UserModel | undefined;
    isUserLoaded: boolean;
}

export const initialAuthState: AuthState = {
    loggedIn: false,
    authToken: undefined,
    user: undefined,
    isUserLoaded: false
};

export function authReducer(state = initialAuthState, action: AuthActions): AuthState {
    switch (action.type) {
        case AuthActionTypes.LOGIN: {
            const token: string = action.payload.authToken;
            return {
                loggedIn: true,
                authToken: token,
                user: undefined,
                isUserLoaded: false
            };
        }
        case AuthActionTypes.REGISTER_USER: {
            const token: string = action.payload.authToken;
            return {
                loggedIn: true,
                authToken: token,
                user: undefined,
                isUserLoaded: false
            };
        }
        case AuthActionTypes.CURRENT_USER_LOADED: {
            const user: UserModel = action.payload.user;
            return {
                ...state,
                user,
                isUserLoaded: true
            };
        }
        default: return state;
    }
}
